var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchGray = function SvgSearchGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "search-gray",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.012,
    height: 19.997
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.731 18.311-3.71-3.68a9 9 0 1 0-1.39 1.39l3.68 3.68a.994.994 0 1 0 1.42-1.39Zm-10.71-2.29a7 7 0 1 1 7-7 7 7 0 0 1-7 7Z"
  })));
};
export default SvgSearchGray;